module.exports = __webpack_public_path__ + "static/media/mobile-step1-ar.7e6ba398.png";